import http from "../../Http/Http-processcommon";
import http2 from "../../Http/Http-processcommon2";
const NombreDelModulo = "agendaLegislativaActividades";

class AgendaActividadDataService {
    async create(data) {
        return await http.post(`/${NombreDelModulo}`, data);
    }
    async update(id, data) {
        return await http2.post(`/${NombreDelModulo}/${id}`, data);
    }
    async getAll(idAgenda,idFilter, search = "", page = 1, rows = 4) {
        return await http.get(
            `/${NombreDelModulo}?idAgenda=${idAgenda}&idFilter=${idFilter}&search=${search}&page=${page}&rows=${rows}`
        );
    }
    async get(id) {
        return await http.get(`/${NombreDelModulo}/${id}`);
    }
    async delete(id) {
        return await http.delete(`/${NombreDelModulo}/${id}`);
    }
    async patch(id) {
        return await http.patch(`/${NombreDelModulo}/patch/${id}`);
    }
    async getTotalRecords(idFilter,idAgenda, search) {
        return await http.get(
            `/${NombreDelModulo}/totalrecords?idFilter=${idFilter}&idAgenda=${idAgenda}&search=${search}`
        );
    } 
    async getAllProyectosLeySearch(search = "",page = 1,rows = 4) {
        return await http.get(
            `/utils/getAllProyectosLeySearch?search=${search}&page=${page}&rows=${rows}`
        );
    }
    async getAllProyectosLeySearchtotalrecords(search = "") {
        return await http.get(
            `/utils/getAllProyectosLeySearchtotalrecords?search=${search}`
        );
    }
    async getAllCitacionesSearch(search = "",page = 1,rows = 4) {
        return await http.get(
            `utils/getAllCtrlPoliticoSearch?search=${search}&page=${page}&rows=${rows}`
        );
    }
    async getAllCitacionesSearchtotalrecords(search = "") {
        return await http.get(
            `utils/getAllCtrlPoliticoSearchtotalrecords?search=${search}`
        );
    }  
}

export default new AgendaActividadDataService();
